module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_1@2x.345f2918.png";